import React from 'react';
import { Link } from 'react-router-dom';

const PrivacyPolicy = () => {
  return (
    <div>
      <section className="privacy-content">
        <div className="container">
          <Link to="/" className="back-link">← Back to App Details</Link>

          <h1>Privacy Policy</h1>
          <p><strong>Last updated: January 2024</strong></p>

          <p>
            Benefit Mankind Charity UK ("we," "our," or "us") is committed to protecting your privacy.
            This Privacy Policy explains how we collect, use, disclose, and safeguard your information
            when you use our mobile application and related services.
          </p>

          <h2>1. Information We Collect</h2>

          <h3>1.1 Personal Information</h3>
          <p>We may collect the following types of personal information:</p>
          <ul>
            <li>Name and contact information (email address)</li>
            <li>Payment information (processed securely through third-party payment processors)</li>
            <li>Donation history</li>
            <li>Push notification tokens (automatically generated by the system for sending notifications)</li>
          </ul>

          <h2>2. How We Use Your Information</h2>
          <p>We use the collected information for the following purposes:</p>
          <ul>
            <li>Process and manage your donations</li>
            <li>Provide customer support and respond to inquiries</li>
            <li>Send you push notifications about new projects and donation updates (using automatically generated device tokens)</li>
            <li>Send you updates about our charitable activities and impact</li>
            <li>Improve our app functionality and user experience</li>
            <li>Comply with legal obligations and regulatory requirements</li>
            <li>Prevent fraud and ensure security</li>
            <li>Generate anonymous statistics and reports</li>
          </ul>

          <h3>2.1 Push Notifications</h3>
          <p>
            Our app uses Expo's push notification service, which automatically generates a push notification token for your device.
            This token allows us to send you notifications about new charitable projects and donation updates. We only collect
            and store this notification token - we do not directly access or collect your device's unique hardware identifiers.
            The push notification token is generated and managed entirely by the Expo notification system.
          </p>

          <h2>3. Information Sharing and Disclosure</h2>
          <p>We do not sell, trade, or rent your personal information to third parties. We may share your information only in the following circumstances:</p>
          <ul>
            <li><strong>Service Providers:</strong> With trusted third-party service providers who assist us in operating our app and processing donations (including Stripe for payment processing)</li>
            <li><strong>Legal Requirements:</strong> When required by law or to protect our rights and the safety of our users</li>
            <li><strong>Consent:</strong> When you have given explicit consent for specific sharing</li>
            <li><strong>Business Transfers:</strong> In connection with a merger, acquisition, or sale of assets</li>
          </ul>

          <h2>4. Data Security</h2>
          <p>
            We implement appropriate technical and organizational measures to protect your personal information against
            unauthorized access, alteration, disclosure, or destruction. This includes:
          </p>
          <ul>
            <li>Encryption of sensitive data in transit and at rest</li>
            <li>Regular security assessments and updates</li>
            <li>Access controls and authentication measures</li>
            <li>Secure payment processing through certified providers (Stripe)</li>
          </ul>

          <h2>5. Data Retention</h2>
          <p>
            We retain your personal information only for as long as necessary to fulfill the purposes outlined in this
            Privacy Policy, unless a longer retention period is required or permitted by law.
          </p>

          <h2>6. Your Rights and Choices</h2>
          <p>Under applicable data protection laws, you have the following rights:</p>
          <ul>
            <li><strong>Access:</strong> Request access to your personal information</li>
            <li><strong>Correction:</strong> Request correction of inaccurate or incomplete information</li>
            <li><strong>Deletion:</strong> Request deletion of your personal information</li>
            <li><strong>Portability:</strong> Request a copy of your data in a portable format</li>
            <li><strong>Objection:</strong> Object to certain processing of your information</li>
            <li><strong>Withdrawal of Consent:</strong> Withdraw consent where processing is based on consent</li>
          </ul>

          <h2>8. Third-Party Links</h2>
          <p>
            Our app may contain links to third-party websites or services. We are not responsible for the privacy
            practices of these external sites. We encourage you to review their privacy policies before providing
            any personal information.
          </p>

          <h2>9. International Data Transfers</h2>
          <p>
            Your information may be transferred to and processed in countries other than your country of residence.
            We ensure appropriate safeguards are in place to protect your information in accordance with applicable
            data protection laws.
          </p>

          <h2>10. Children's Privacy</h2>
          <p>
            Our app is not intended for children under 13 years of age. We do not knowingly collect personal
            information from children under 13. If we become aware that we have collected such information,
            we will take steps to delete it promptly.
          </p>

          <h2>11. Changes to This Privacy Policy</h2>
          <p>
            We may update this Privacy Policy from time to time. We will notify you of any material changes by
            posting the new Privacy Policy in our app and updating the "Last updated" date. Your continued use
            of our app after such changes constitutes acceptance of the updated policy.
          </p>

          <h2>12. Contact Information</h2>
          <p>
            If you have any questions about this Privacy Policy or our data practices, please contact us:
          </p>
          <ul>
            <li><strong>Email:</strong> info@benefitmankind.co.uk</li>
            <li><strong>Address:</strong> Benefit Mankind UK Head Office, Blackburn Enterprise Centre, Suite 01, Furthergate, Blackburn, BB1 3HQ, United Kingdom</li>
            <li><strong>Phone:</strong> 01254 602598</li>
          </ul>

          <h2>13. Regulatory Compliance</h2>
          <p>
            This Privacy Policy complies with the UK General Data Protection Regulation (UK GDPR) and the Data
            Protection Act 2018. We are registered with the Information Commissioner's Office (ICO) as a data
            controller.
          </p>

          <div style={{ marginTop: '3rem', padding: '2rem', backgroundColor: '#f8f9fa', borderRadius: '8px' }}>
            <p><strong>Note:</strong> This privacy policy is designed to meet the requirements for app store submissions
              and provides comprehensive coverage of data handling practices for the Benefit Mankind charity donation app.</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
